<template>
  <div class="LmInput relative mb-8">
    <label
      class="block mb-1 font-mono text-xxs uppercase tracking-wider text-gray-500"
      >Enter tags
      <template v-if="!required">(optional)</template>
    </label>
    <v-select
      v-model="value"
      class="LmTagsSelector"
      :class="{'is-error': error}"
      :options="options"
      max-height="280px"
      multiple
      taggable
      push-tags
      :create-option="newTag"
      :close-on-select="false"
      :on-change="onChange"
    />
    <span v-if="error" class="block w-full text-xs text-error pt-1"
      >Please enter at least one tag</span
    >
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'LmTagsSelector',
  components: {
    vSelect
  },
  props: {
    tags: {
      type: Array,
      default: function() {
        return []
      }
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: Array,
      error: false
    }
  },
  computed: {
    data() {
      return this.value.map(tag => tag.label || tag)
    }
  },
  watch: {
    tags() {
      this.bootstrap()
    }
  },
  mounted() {
    this.bootstrap()
  },
  methods: {
    onChange(v) {
      this.value = v
      this.error = false
    },
    newTag(value) {
      return {label: value}
    },
    bootstrap() {
      this.value = this.tags.slice()
    },
    reset() {
      this.error = false
      this.bootstrap()
    },
    validateData() {
      this.error = false
      if (!this.required || this.value.length > 0) return true
      else {
        this.error = true
        return false
      }
    },
    clearErrors() {}
  }
}
</script>

<style>
.LmTagsSelector.is-error .dropdown-toggle {
  border-bottom: 1px solid theme('colors.error') !important;
}
</style>
